import { render, staticRenderFns } from "./detail-clear.vue?vue&type=template&id=14fb9272&scoped=true&"
import script from "./detail-clear.vue?vue&type=script&lang=js&"
export * from "./detail-clear.vue?vue&type=script&lang=js&"
import style0 from "./detail-clear.vue?vue&type=style&index=0&id=14fb9272&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14fb9272",
  null
  
)

export default component.exports